import search from './search'
import errors from './errors'
import layout from './layout'

export default {
  search,
  errors,
  layout
}
